import React, { Component } from 'react';
import { Container, Button } from 'semantic-ui-react';
import { PtInput, PtSelect, PtSelectAndEstimate, PtInputAndEstimate, PtTextBox } from '../../../grit-utilities';
import ScrollArea from 'react-scrollbar';
import DropdownLib from '../../../DropdownLib';

export default class LastProjectSurf extends Component {

    constructor(props) {
        super(props);

        const { csModel } = this.props;

        this.state = csModel.lpModel;

        // Set visibilities for lastProjectSurf subtypes
        this.changeTypeVisibilities(this.state.lastProjectSurf);
    }

    render() {

        const {
            lpTypeOptions,
            lpSurfOptions,
            gravelTypeOptions,
            gravelTrtOptions,
            bitTypeOptions,
            concrTypeOptions,
            astTypeOptions,
            compTypeOptions,
            dptOptions } = DropdownLib.getDropdowns().CS_LastProjectSurf;

        return (
            <Container>
                <ScrollArea
                    speed={1}
                    className={!window.mobileAndTabletcheck() ? "area_desktop" : "area_mobile"}
                    contentClassName="content"
                    smoothScrolling={true}>

                    <PtSelect label="Last Project Type" options={lpTypeOptions} defaultVal={this.state.lastProjectType} disabled={this.props.disabled}
                        onChange={this.onChangeDropdown} name="lastProjectType" />

                    {/*<span style={{ color: 'red' }}>Affects Maintenance Layers</span>*/}
                    <b>
                        <PtSelect label="Last Project Surface" options={lpSurfOptions} defaultVal={this.state.lastProjectSurf} disabled={this.props.disabled}
                            onChange={this.onChangeLPSurf} name="lastProjectSurf" />
                    </b>
                    <PtSelect label="Gravel Type" options={gravelTypeOptions} defaultVal={this.state.gravelType} disabled={this.props.disabled}
                        onChange={this.onChangeDropdown} name="gravelType" display={this.gravelVis} />

                    <PtSelect label="Gravel Treatment" options={gravelTrtOptions} defaultVal={this.state.gravelTreatment} disabled={this.props.disabled}
                        onChange={this.onChangeDropdown} name="gravelTreatment" display={this.gravelVis} />

                    <PtSelect label="Bituminous Type" options={bitTypeOptions} defaultVal={this.state.bitType} disabled={this.props.disabled}
                        onChange={this.onChangeDropdown} name="bitType" display={this.bituminousVis} />

                    <PtSelect label="Concrete Type" options={concrTypeOptions} defaultVal={this.state.concrType} disabled={this.props.disabled}
                        onChange={this.onChangeDropdown} name="concrType" display={this.concreteVis} />

                    <PtSelect label="AST Type" options={astTypeOptions} defaultVal={this.state.astType} disabled={this.props.disabled}
                        onChange={this.onChangeDropdown} name="astType" display={this.astVis} />

                    <PtSelect label="Composite Type" options={compTypeOptions} defaultVal={this.state.compType} disabled={this.props.disabled}
                        onChange={this.onChangeDropdown} name="compType" display={this.compositeVis} />

                    <PtInputAndEstimate inputType="year" placeholder="1990" label="Last Project Year" value={this.state.lastProjectYear} disabled={this.props.disabled}
                        onChange={this.onInputChange} name="lastProjectYear" estimated={this.state.lastProjectYearEst} />

                    <PtSelectAndEstimate label="Last Project Surface Depth (inches)" options={dptOptions} defaultVal={this.state.lpDepth} disabled={this.props.disabled}
                        onChange={this.onChangeDropdownEstimated} name="lpDepth" estimated={this.state.lpDepthEst} />

                    <PtSelectAndEstimate label="Total Surface Depth (inches)" options={dptOptions} defaultVal={this.state.totalDepth} disabled={this.props.disabled}
                        onChange={this.onChangeDropdownEstimated} name="totalDepth" estimated={this.state.totalDepthEst} />

                    <PtInput inputType="money" placeholder="0" label="Last Project Cost Per Mile" value={this.state.lastProjectMile}
                        onChange={this.onInputChange} name="lastProjectMile" disabled={this.props.disabled} />

                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ flex: '3' }}>
                            <PtTextBox label="Plans on County Server URL.pdf" value={this.state.planURL}
                                onChange={this.onInputChange} name="planURL" disabled={this.props.disabled} />
                        </div>
                        <div style={{ flex: '1' }}>
                            <Button size='tiny' color='blue' style={{ 'padding-left': '1em', 'padding-right': '1em', 'padding-top': '.6em', 'padding-bottom': '.6em' }}
                                onClick={() => {
                                    if (this.state.planURL) {
                                        window.open(this.state.planURL, '_blank', 'noopener,noreferrer');
                                    }
                                }}>
                                View</Button>
                        </div>
                    </div>

                    <PtTextBox label="Comment" value={this.state.comment} onChange={this.onInputChange} name="comment" disabled={this.props.disabled} />

                </ScrollArea>
            </Container>
        );
    }

    onChangeDropdown = (e) => {
        const { target } = e;
        const { name, value } = target;
        this.props.triggerNeedSave();
        // eslint-disable-next-line
        this.setState({ [name]: parseInt(value) });
    }

    onChangeDropdownEstimated = (e) => {
        const { target } = e;
        const { name, value } = target;
        this.props.triggerNeedSave();

        // Determine if Dropdown value or Estimated value was changed
        // eslint-disable-next-line
        if ((parseFloat(value) === parseInt(value)) && !isNaN(value)) {
            // eslint-disable-next-line
            this.setState({ [name]: parseInt(value) });
        } else {
            this.setState({ [name]: value });
        }
    }

    onChangeLPSurf = (e) => {
        const { target } = e;
        const { name, value } = target;
        this.props.triggerNeedSave();
        // eslint-disable-next-line
        this.setState({ [name]: parseInt(value) });

        // Change visibility of conditional fields
        // eslint-disable-next-line
        this.changeTypeVisibilities(parseInt(value));
    }

    onInputChange = (e) => {
        const { name, value } = e.target;
        this.props.triggerNeedSave();
        if (name === 'comment' || name === 'planURL')
            this.setState({ [name]: value });
        // eslint-disable-next-line
        else this.setState({ [name]: value === '' ? null : parseFloat(value) });
    }

    changeTypeVisibilities(value) {
        // set all to not visible
        this.gravelVis = 'none';
        this.bituminousVis = 'none';
        this.concreteVis = 'none';
        this.astVis = 'none';
        this.compositeVis = 'none';

        // set chosen type to visible
        // eslint-disable-next-line
        switch (value) {
            case 1:
                this.gravelVis = 'block';
                break;
            case 2:
                this.bituminousVis = 'block';
                break;
            case 3:
                this.concreteVis = 'block';
                break;
            case 4:
                this.astVis = 'block';
                break;
            case 5:
                this.compositeVis = 'block';
                break;
        }
    }

    componentDidUpdate() {
        //console.log(this.state); 
        this.props.csModel.lpModel = this.state;
    }
}



// WEBPACK FOOTER //
// ./src/layers/tabs/cons-segment/last-project-surf.js